module.exports = __webpack_public_path__ + "static/media/015admin_3 cart summary @2x.1b849a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/015admin_3 cart summary @2x.png
// module id = 579
// module chunks = 0